import React from 'react';
import type TTab from './types/TTab';
import Box from '../Box/Box';
import { TextLarge } from '../Text';
import { isEnterOrSpace } from '../../utils/keyboard';

function getModifier(isActive?: boolean): string[] {
  return isActive ? ['active'] : [];
}

function calcTextType(isActive?: boolean): 'strong' | 'span' {
  return isActive ? 'strong' : 'span';
}

function makeKeyDownHandler(onClick?: () => void) {
  return (event: React.KeyboardEvent) => {
    if (!isEnterOrSpace(event.key)) return;
    event.preventDefault();
    onClick?.();
  };
}

const Tab = ({ label, onClick, isActive, id, ...otherProps }: TTab) => {
  return (
    <Box
      as="button"
      name="TabNextButton"
      onClick={onClick}
      onKeyDown={makeKeyDownHandler(onClick)}
      modifiers={getModifier(isActive)}
      role="tab"
      aria-selected={isActive}
      aria-controls={`tab-${id}`}
      id={`tab-${id}`}
      {...otherProps}
    >
      <Box as="div" name="TabNext" modifiers={getModifier(isActive)}>
        <TextLarge as={calcTextType(isActive)}>{label}</TextLarge>
      </Box>
    </Box>
  );
};

export default Tab;
